export const HideTransferBalance: React.FC = () => {
  return (
    <div className="w-1/2 flex flex-col h-10 animate-pulse items-center mb-2 mt-2">
      <div className="w-full h-3 bg-gray-300 rounded-[17px]" />
      <div className="w-full mt-3 h-3  bg-gray-300 rounded-[17px]" />
    </div>
  );
}